<template>
  <section id="hero">
    <div class="video-wrapper">
      <iframe width="100%" height="56.25%" src="https://www.youtube.com/embed/RE9WRwqVNLY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$green1: #69FA6C;
$green2: #00c404;

#hero {
  padding-bottom: 0;
  margin-top: 60px;
  padding-top: 40px;
  padding: 16px 0;
  background: black;
}

.video-wrapper {
  position: relative;
}

iframe {
  width: 100vw;
  height: 56.25vw;
}

@media screen and (min-width: 768px) {
  #hero {
    padding-top: 0;
    margin-top: 87px;
  }
}
</style>
